export enum CalendarType {
    CUSTOM = "Custom",
    TUNIFY = "Tunify"
}
